export default function IconTicket({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M13 5.85718V7.85718M13 17.8572V19.8572M13 11.8572V13.8572M2 9.85718C2.79565 9.85718 3.55871 10.1732 4.12132 10.7359C4.68393 11.2985 5 12.0615 5 12.8572C5 13.6528 4.68393 14.4159 4.12132 14.9785C3.55871 15.5411 2.79565 15.8572 2 15.8572V17.8572C2 18.3876 2.21071 18.8963 2.58579 19.2714C2.96086 19.6465 3.46957 19.8572 4 19.8572H20C20.5304 19.8572 21.0391 19.6465 21.4142 19.2714C21.7893 18.8963 22 18.3876 22 17.8572V15.8572C21.2044 15.8572 20.4413 15.5411 19.8787 14.9785C19.3161 14.4159 19 13.6528 19 12.8572C19 12.0615 19.3161 11.2985 19.8787 10.7359C20.4413 10.1732 21.2044 9.85718 22 9.85718V7.85718C22 7.32674 21.7893 6.81804 21.4142 6.44296C21.0391 6.06789 20.5304 5.85718 20 5.85718H4C3.46957 5.85718 2.96086 6.06789 2.58579 6.44296C2.21071 6.81804 2 7.32674 2 7.85718V9.85718Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
